import { appOrganizationInitialState } from './appOrganization.initialState';
import { path, pathOr } from 'ramda';
import { createSelector } from 'reselect';

export const getPendingAppOrganizationUpdate = state =>
	path(['appOrganization', 'pendingUpdate'], state);
export const getPendingAppOrganizationCreate = state =>
	path(['appOrganization', 'pendingCreate'], state);
export const getPendingAppOrganizations = state => ({
	update: getPendingAppOrganizationUpdate(state),
	create: getPendingAppOrganizationCreate(state),
});

export const getAppOrganizationErrorUpdate = state =>
	path(['appOrganization', 'updateError'], state);
export const getAppOrganizationErrorCreate = state =>
	path(['appOrganization', 'createError'], state);
export const getAppOrganizationErrors = state => ({
	update: getAppOrganizationErrorUpdate(state),
	create: getAppOrganizationErrorCreate(state),
});

export const getAppOrganizationById = (state, id) =>
	pathOr({}, ['appOrganization', 'entities'], state)[id] || appOrganizationInitialState;
export const getEntities = state => path(['appOrganization', 'entities'], state);
export const getAppOrganizations = createSelector(getEntities, entities => Object.values(entities));



// WEBPACK FOOTER //
// ./src/redux/appOrganizations/appOrganization.selector.js